import { useMemo } from 'react';
import { createAuthenticatedApiClient } from '../../../shared/api/apiClient';
import { rpcCall } from '../../../shared/api/rpcClient';
import { useAuth } from '../../auth/context/AuthContext';

/** The persisted overlay for one tool — admin-edited deltas over the code definition. */
export interface ToolConfig {
  action_id: string;
  description_override?: string;
  /** undefined/true = enabled for agents; false = operator kill switch. */
  enabled?: boolean;
  updated_at: string;
  updated_by?: string;
}

/** Partial update — only the override fields to change. */
export interface ToolConfigUpdate {
  description_override?: string;
  enabled?: boolean;
}

export const createToolConfigService = (idToken: string) => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    listToolConfigs: async (): Promise<ToolConfig[]> =>
      rpcCall<ToolConfig[]>(client, 'toolset.ListToolConfigs'),

    upsertToolConfig: async (actionId: string, update: ToolConfigUpdate): Promise<ToolConfig> =>
      rpcCall(client, 'toolset.UpsertToolConfig', { action_id: actionId, ...update }),
  };
};

export const useToolConfigService = () => {
  const { idToken } = useAuth();
  return useMemo(() => (idToken ? createToolConfigService(idToken) : null), [idToken]);
};
